import React, { Component } from "react";
import {
  alert,
  toFixed,
  format_date,
  GET,
  loading,
  Status,
  DateRangePicker,
  Navbar,
  Modal,
  profile,
} from "../../components/CustomComponent.js";
import Footer from "../../components/Footer.js";
import {
  report_preorder,
  report_tax_invoice,
} from "../../components/Report.js";
import HELP0001 from "../../assets/images/help/0001.png";
import HELP0002 from "../../assets/images/help/0002.png";
import HELP0011 from "../../assets/images/help/0011.png";
import HELP0012 from "../../assets/images/help/0012.png";
import "bootstrap/dist/css/bootstrap.min.css";
const help = [
  { 
    title: "การสั่งซื้อ",
    array: [
      {
        title: "ฉันสามารถซื้อสินค้าและชำระเงินโดยไม่มีบัญชีได้หรือไม่?", 
        detail: (
          <div>
            <p className="mb-3">คุณไม่สามารถสั่งซื้อสินค้าและชำระเงินโดยไม่มีบัญชีผู้ใช้งานในระบบได้</p>
            <div className="alert alert-info py-2 px-3 mb-0">
              <p className="mb-0">
                <a href="/register" className="fw-bold text-decoration-none">การสร้างบัญชี</a> จะช่วยให้คุณสามารถจัดการข้อมูลที่จำเป็นในการสั่งซื้อสินค้าได้อย่างปลอดภัย เช่น ที่อยู่จัดส่ง การติดตามสถานะพัสดุ และประวัติการสั่งซื้อของคุณ
              </p>
            </div>
          </div>
        )
      },
      {
        title: "ฉันจะลบสินค้าออกจากรถเข็นได้อย่างไร?", 
        detail: (
          <div>
            <ol className="mb-0">
              <li className="mb-4">
                <p className="fw-bold mb-2">เข้าสู่รถเข็นของคุณ</p>
                <p className="text-muted mb-3">เลือกสินค้าที่คุณต้องการนำออก จากนั้นกดปุ่ม <b>"ลบ"</b> ที่อยู่ด้านข้างรายการสินค้า</p>
                <img src={HELP0001} alt="ขั้นตอนการลบสินค้า 1" className="img-fluid rounded border w-100 mb-2"/>
              </li>
              <li>
                <p className="fw-bold mb-2">ยืนยันการลบสินค้า</p>
                <p className="text-muted mb-3">ระบบจะแสดงหน้าต่างยืนยัน ให้กด <b>"ลบสินค้า"</b> อีกครั้งเพื่อนำสินค้าออกจากรถเข็นของคุณอย่างสมบูรณ์</p>
                <img src={HELP0002} alt="ขั้นตอนการลบสินค้า 2" className="img-fluid rounded border w-100"/>
              </li>
            </ol>
          </div>
        )
      },
      {
  title: "ฉันสามารถเปลี่ยนที่อยู่จัดส่งหลังจากทำการสั่งซื้อได้หรือไม่?", 
  detail: (
    <div>
      <p>โดยปกติแล้วระบบ <b>ไม่สามารถเปลี่ยนที่อยู่จัดส่งได้ด้วยตนเอง</b> หลังจากยืนยันคำสั่งซื้อเรียบร้อยแล้ว</p>
      <hr />
      <h6 className="fw-bold">หากต้องการแก้ไขข้อมูล:</h6>
      <p className="text-muted">
        กรุณาติดต่อเจ้าหน้าที่ผ่านทาง Line OA หรือแจ้งฝ่ายบริการลูกค้าผ่านอีเมลโดยเร็วที่สุด เพื่อตรวจสอบว่าพัสดุถูกส่งออกไปแล้วหรือไม่
      </p>
      <div className="alert alert-danger py-2 mb-0">
        <b>⚠️ หมายเหตุ:</b> หากพัสดุถูกส่งออกไปแล้ว (สถานะ 'ระหว่างขนส่ง') จะไม่สามารถแก้ไขที่อยู่ได้ในทุกกรณี 
      </div>
    </div>
  )
}
    ]
  },
  { 
    title: "การชำระเงิน",
    array: [
      {
  title: "ช่องทางการชำระเงินที่ระบบรองรับมีอะไรบ้าง?", 
  detail: (
    <div>
      <p>ปัจจุบันระบบของเรารองรับการชำระเงินผ่านช่องทางเดียว เพื่อความรวดเร็วและปลอดภัย:</p>
      <ul className="mb-0">
        <li className="mb-2">
          <b>Thai QR Payment (PromptPay):</b> 
          คุณสามารถบันทึกรูป QR Code เพื่อสแกนจ่ายผ่านแอปพลิเคชันของทุกธนาคาร
        </li>
      </ul>
      <div className="alert alert-info py-2 mt-3 mb-0">
        <b>💡 ข้อดี:</b> ระบบจะตรวจสอบยอดเงินและยืนยันคำสั่งซื้อให้คุณ <b>โดยอัตโนมัติทันที</b> ไม่ต้องเสียเวลาส่งสลิปให้เจ้าหน้าที่ครับ
      </div>
    </div>
  )
},
      {
        title: "ข้อควรระวังในการชำระเงิน", 
        detail: (
          <div className="alert alert-danger mb-0">
            <h6 className="fw-bold mb-2">🛑 นโยบายความปลอดภัยทางการเงิน</h6>
            <p className="mb-0">เพื่อให้การซื้อขายเป็นไปตามนโยบายของทางบริษัท <b>บริษัทไม่มีนโยบายส่ง QR Code หรือหมายเลขบัญชีสำหรับการชำระเงินผ่านทางแชทส่วนตัว หรือช่องทางอื่นใดนอกระบบโดยเด็ดขาด</b></p>
            <hr className="my-2" border-color="currentColor"/>
            <p className="mb-0 text-sm">เราขอแนะนำให้ผู้ซื้อชำระค่าสินค้าผ่านทางหน้าระบบ Checkout ของเว็บไซต์เท่านั้น เพื่อให้ทางเราสามารถคุ้มครองยอดเงินของคุณจนกว่าจะได้รับสินค้าอย่างปลอดภัย</p>
          </div>
        )
      },
      {
        title: "ถ้าโอนเงินให้ผิดผู้รับ หรือกรอกยอดเงินผิดต้องทำอย่างไร?", 
        detail: (
          <div>
            <p>หากคุณโอนเงินผ่านระบบไปยังผู้รับที่ไม่ถูกต้อง หรือโอนยอดเงินไม่ตรงกับคำสั่งซื้อ กรุณาดำเนินการดังนี้:</p>
            <ol className="text-muted mb-4">
              <li>เตรียมหลักฐานการโอนเงิน (สลิปธนาคาร) และหมายเลขคำสั่งซื้อของคุณ</li>
              <li>ติดต่อฝ่ายบริการลูกค้าสัมพันธ์ของเราทันที เพื่อขอความช่วยเหลือในการตรวจสอบยอดเงินและปรับปรุงสถานะคำสั่งซื้อ</li>
            </ol>
            <div className="alert alert-warning mb-0">
              <p className="fw-bold mb-1">⚠️ หมายเหตุสำคัญ</p>
              <p className="mb-0">ในกรณีที่เป็นการโอนเงินผิดบัญชีไปยังบุคคลภายนอก (ที่ไม่ได้อยู่ในระบบของเรา) ทางเราจะไม่สามารถดึงเงินกลับหรือรับประกันการคืนเงินได้ คุณควรตรวจสอบชื่อบัญชีผู้รับและยอดเงินให้ตรงกับระบบก่อนกดยืนยันการโอนทุกครั้ง</p>
            </div>
          </div>
        )
      },
      {
        title: "จะเกิดอะไรขึ้นถ้าฉันไม่ได้ชำระเงินภายในเวลาที่กำหนด?", 
        detail: (
          <div>
            <p className="mb-0">สำหรับคำสั่งซื้อที่เลือกช่องทางชำระเงินแบบ <b>โอนเงิน หรือ QR Code</b> ระบบจะให้ระยะเวลาในการชำระเงินตามที่ระบุไว้ในหน้าคำสั่งซื้อ (โดยปกติคือ 24 - 48 ชั่วโมง) <br/><br/>หากไม่มีการชำระเงินและแจ้งโอนภายในเวลาที่กำหนด <b>รายการคำสั่งซื้อสินค้าของคุณจะถูกยกเลิกโดยอัตโนมัติ</b> เพื่อปล่อยสต็อกสินค้าให้กับลูกค้ารายอื่นต่อไป หากคุณยังต้องการสินค้า กรุณาทำรายการสั่งซื้อเข้ามาใหม่อีกครั้ง</p>
          </div>
        )
      }
    ]
  },
  { 
    title: "การจัดการคำสั่งซื้อ",
    array: [
      {
        title: "สถานะคำสั่งซื้อของฉัน หมายความว่าอย่างไร?", 
        detail: (
          <div>
            <p className="mb-4">หลังจากที่คุณทำการสั่งซื้อ คุณสามารถติดตามสถานะพัสดุได้ โดยแต่ละสถานะมีความหมายดังนี้:</p>
            <div className="timeline-container ps-3 border-start border-3 border-primary">
              <div className="mb-3">
                <span className="fw-bold text-primary">💳 ที่ต้องชำระเงิน</span>
                <p className="text-muted small mb-0 mt-1">คำสั่งซื้อของคุณอยู่ระหว่างรอการชำระเงิน กรุณาทำการชำระเงินและแจ้งโอนภายในเวลาที่กำหนด เพื่อให้ระบบยืนยันคำสั่งซื้อ</p>
              </div>
              <div className="mb-3">
                <span className="fw-bold text-warning">📦 ที่ต้องจัดส่ง</span>
                <p className="text-muted small mb-0 mt-1">ชำระเงินสำเร็จ ระบบกำลังแจ้งร้านค้าให้จัดเตรียมพัสดุ (โดยทั่วไปใช้เวลาจัดเตรียมพัสดุ 1-3 วันทำการ ยกเว้นสินค้า Pre-order)</p>
              </div>
              <div className="mb-3">
                <span className="fw-bold text-info">🚚 ระหว่างขนส่ง</span>
                <p className="text-muted small mb-0 mt-1">ร้านค้าได้ส่งมอบพัสดุให้บริษัทขนส่งเรียบร้อยแล้ว พัสดุกำลังเดินทางไปยังศูนย์คัดแยกและนำจ่ายไปยังที่อยู่ของคุณ</p>
              </div>
              <div className="mb-3">
                <span className="fw-bold text-success">✅ จัดส่งแล้ว</span>
                <p className="text-muted small mb-0 mt-1">พัสดุของคุณได้รับการจัดส่งถึงมือผู้รับสำเร็จแล้ว</p>
              </div>
              <div className="mb-3">
                <span className="fw-bold text-secondary">↩️ การคืนสินค้า</span>
                <p className="text-muted small mb-0 mt-1">คำสั่งซื้อนี้อยู่ระหว่างกระบวนการขอคืนเงินหรือส่งคืนสินค้า</p>
              </div>
              <div className="mb-0">
                <span className="fw-bold text-danger">❌ การยกเลิก</span>
                <p className="text-muted small mb-0 mt-1">คำสั่งซื้อถูกยกเลิก (อาจเกิดจากผู้ซื้อยกเลิกเอง, ไม่ชำระเงินตามกำหนด, หรือสินค้าหมดสต็อก)</p>
              </div>
            </div>
          </div>
        )
      },
      {
        title: "ทำไมคำสั่งซื้อของฉันจึงไม่เปลี่ยนเป็น 'ที่ต้องจัดส่ง'?", 
        detail: (
          <div>
            <p>ในกรณีที่คำสั่งซื้อของคุณไม่เปลี่ยนสถานะไปสู่ <b>‘ที่ต้องจัดส่ง’</b> อาจเกิดจากสาเหตุต่อไปนี้:</p>
            <ul className="text-muted">
              <li><b>รอการตรวจสอบยอดเงิน:</b> หากคุณเลือกชำระแบบโอนเงิน ระบบหรือเจ้าหน้าที่อาจกำลังใช้เวลาในการตรวจสอบหลักฐานการชำระเงินของคุณ (ใช้เวลาไม่เกิน 24 ชั่วโมง)</li>
              <li><b>ผู้ขายยังไม่ได้ดำเนินการ:</b> ผู้ขายอาจยังไม่ได้ทำการแพ็คสินค้าหรือนำสินค้าไปส่งมอบให้บริษัทขนส่ง คุณสามารถติดต่อสอบถามกับผู้ขายโดยตรงผ่านช่องทางแชท</li>
            </ul>
            <p className="mb-0 text-danger fw-bold">หากผู้ขายไม่ทำการจัดส่งสินค้าภายในช่วงเวลาที่แพลตฟอร์มกำหนด คำสั่งซื้อของคุณจะได้รับการยกเลิกโดยอัตโนมัติ และระบบจะดำเนินการคืนเงินให้คุณทันที</p>
          </div>
        )
      },
      {
        title: "ฉันควรทำอย่างไร หากฉันไม่ได้รับสินค้าที่สั่งซื้อไป", 
        detail: (
          <div>
            <p>หากเกินกำหนดระยะเวลาจัดส่งที่คาดการณ์ไว้แล้ว แต่คุณยังไม่ได้รับสินค้า สามารถตรวจสอบเบื้องต้นได้ดังนี้:</p>
            <ol className="text-muted mb-4">
              <li className="mb-2">
                ไปที่ <b>เมนูโปรไฟล์</b> {">"} <b>การซื้อของฉัน</b>
                <br/><img src={HELP0011} className="img-fluid rounded border mt-2" width={"50%"} alt="เมนูการซื้อของฉัน"/>
              </li>
              <li className="mb-2">
                ตรวจสอบว่าคำสั่งซื้อปัจจุบันอยู่ในสถานะใด และนำเลข Tracking ไปตรวจสอบกับเว็บไซต์ของบริษัทขนส่งโดยตรง
                <br/><img src={HELP0012} className="img-fluid rounded border mt-2 w-100" alt="สถานะคำสั่งซื้อ"/>
              </li>
              <li>หากสถานะขึ้นว่าจัดส่งแล้ว แต่คุณไม่ได้รับพัสดุ กรุณาสอบถามบุคคลในบ้านหรือนิติบุคคล ก่อนทำการยื่นข้อพิพาท <b>"ขอคืนเงิน/คืนสินค้า"</b> ในระบบ</li>
            </ol>
          </div>
        )
      },
      {
        title: "ฉันสามารถเพิ่มสินค้าในคำสั่งซื้อที่ชำระเงินแล้วได้หรือไม่?", 
        detail: (
          <div>
            <p className="mb-3"><b>ขออภัยในความไม่สะดวก</b> คุณไม่สามารถเพิ่ม ลบ หรือเปลี่ยนแปลงรายการสินค้าได้ หลังจากที่คุณทำการยืนยันและชำระเงินสำหรับคำสั่งซื้อนั้นเรียบร้อยแล้ว</p>
            <p className="mb-0 text-muted">หากคุณยังคงต้องการเพิ่มสินค้าอื่นๆ คุณสามารถ <b>สร้างคำสั่งซื้อใหม่</b> สำหรับสินค้าที่ต้องการเพิ่ม หรือหากต้องการรวมพัสดุ คุณจะต้องกดยกเลิกคำสั่งซื้อเดิม (หากสถานะยังรองรับการยกเลิก) และกดสั่งซื้อสินค้าทั้งหมดเข้ามาพร้อมกันในบิลเดียว</p>
          </div>
        )
      },
      {
        title: "ฉันจะสามารถยกเลิกคำสั่งซื้อของฉันได้อย่างไร?", 
        detail: (
          <div>
            <p>คุณสามารถกดยกเลิกคำสั่งซื้อด้วยตนเองได้ หากสถานะยังเป็น <b>'ที่ต้องชำระเงิน'</b> หรือผู้ขายยังไม่ได้กดเตรียมพัสดุ โดยดำเนินการดังนี้:</p>
            <ol className="text-muted mb-4">
              <li>ไปที่ <b>การซื้อของฉัน</b> และคลิกที่คำสั่งซื้อที่คุณต้องการยกเลิก</li>
              <li>เลื่อนลงมาด้านล่างสุด แล้วกดปุ่ม <b>'ยกเลิกคำสั่งซื้อ'</b></li>
              <li>เลือกเหตุผลในการยกเลิกให้ตรงที่สุด แล้วกด <b>'ยืนยัน'</b></li>
            </ol>
            <div className="alert alert-secondary mb-0">
              <h6 className="fw-bold mb-2">💸 ช่องทางการคืนเงิน (กรณีชำระเงินแล้ว)</h6>
              <p className="mb-0 text-sm">หากคำสั่งซื้อถูกยกเลิกสำเร็จ ระบบจะทำการคืนเงินกลับไปยังช่องทางที่คุณใช้ชำระเงินเข้ามาโดยอัตโนมัติ (ระยะเวลาดำเนินการคืนเงินขึ้นอยู่กับช่องทางที่คุณเลือกใช้ เช่น บัตรเครดิตอาจใช้เวลา 7-15 วันทำการ)</p>
            </div>
          </div>
        )
      },
      {
        title: "การขอคืนเงิน/คืนสินค้า ในกรณีที่สินค้าไม่ตรงตามกำหนด", 
        detail: (
          <div>
            <p className="fw-bold mb-3">เงื่อนไขเบื้องต้นในการคืนเงินหรือคืนสินค้า:</p>
            <ul className="text-muted mb-4">
              <li>สินค้าต้องอยู่ในสภาพเดิมเหมือนกับตอนที่ได้รับ และบรรจุภัณฑ์ต้องถูกผนึกไว้อย่างดี</li>
              <li>สินค้าที่มีการซีลพลาสติกต้องไม่ถูกเปิด แกะ ฉีก หรือทดลองใช้</li>
              <li>ป้ายราคา ป้ายแท็ก และฉลากของสินค้าต้องไม่ถูกตัดออก และต้องอยู่ในสภาพเดิม</li>
              <li>ผู้ซื้อต้องส่งคืนสินค้าพร้อมอุปกรณ์เสริมทั้งหมด (เช่น แผ่นป้องกัน, คู่มือ, อะไหล่สำรอง, ถุงผ้ากันฝุ่น) เพื่อป้องกันความเสียหายระหว่างส่งกลับ</li>
              <li>หากเป็นสินค้าหมวดแฟชั่น สามารถเปิดพัสดุเพื่อตรวจสอบไซส์ได้ แต่สินค้าต้องไม่ผ่านการซัก หรือสวมใส่ใช้งานจริง</li>
            </ul>
            <div className="alert alert-warning mb-0">
              <b>⚠️ ขั้นตอนการพิจารณา:</b> เมื่อคำขอคืนเงินเข้าสู่ระบบ ทางบริษัทจะพิจารณาอนุมัติผ่านหลักฐาน (ภาพถ่าย/วิดีโอ) ที่ผู้ซื้อและร้านค้าส่งเข้ามา <b>กรุณาถ่ายวิดีโอขณะเปิดกล่องพัสดุทุกครั้ง</b> เพื่อใช้เป็นหลักฐานในการเคลมสินค้า
            </div>
          </div>
        )
      }
    ]
  },
  { 
    title: "บัญชีและความปลอดภัย",
    array: [
      {
        title: "ฉันควรทำอย่างไรหากได้รับพัสดุที่ไม่ได้สั่งซื้อ (มิจฉาชีพ)?", 
        detail: (
          <div>
            <p className="fw-bold text-danger mb-3">หากคุณได้รับพัสดุเก็บเงินปลายทาง หรือพัสดุใดๆ ที่ไม่ได้ทำการสั่งซื้อ ห้ามชำระเงินและห้ามเซ็นรับเด็ดขาด และดำเนินการตามขั้นตอนดังนี้:</p>
            
            <ol className="text-muted mb-4">
              <li className="mb-3">
                <b className="text-dark">ตรวจสอบในระบบ ว่ามีการสั่งซื้อจริงหรือไม่</b><br/>
                ไปที่ <b>การซื้อของฉัน</b> ตรวจสอบว่ามีคำสั่งซื้อดังกล่าวถูกสร้างขึ้นจริงหรือไม่
                <ul className="mt-2">
                  <li>หากมีคำสั่งซื้อโผล่ขึ้นมาโดยที่คุณไม่ได้สั่ง: บัญชีของคุณอาจถูกผู้ไม่หวังดีเข้าถึง แนะนำให้ <b>เปลี่ยนรหัสผ่านทันที</b> และติดต่อแอดมินเพื่อระงับบัญชี</li>
                  <li>หากไม่มีคำสั่งซื้อในระบบ: พัสดุนั้นถูกส่งมาจากมิจฉาชีพภายนอก</li>
                </ul>
              </li>
              <li className="mb-3">
                <b className="text-dark">ตรวจสอบกับคนใกล้ชิด</b><br/>
                สอบถามคนในครอบครัวหรือเพื่อน ว่าได้สั่งของมาลงที่อยู่ของคุณ หรือส่งของขวัญมาให้หรือไม่
              </li>
              <li className="mb-3">
                <b className="text-dark">รายงานปัญหาแพลตฟอร์ม (ถ้าระบุชื่อร้านในระบบได้)</b><br/>
                หากหน้ากล่องพัสดุมีการแอบอ้างชื่อร้านค้าในระบบของเรา กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อรายงานพฤติกรรม ทางเราจะตรวจสอบและลงโทษร้านค้าที่ทำผิดกฎปลอมแปลงข้อมูล
              </li>
            </ol>
  
            <h6 className="fw-bold mt-4 border-bottom pb-2">📍 ทำไมฉันถึงได้รับพัสดุที่ไม่ได้สั่งซื้อ?</h6>
            <p className="text-muted mb-4">
              ร้านค้าบางแห่งใช้วิธีที่ผิดกฎ (Brushing Scam) โดยการส่งของเปล่า หรือของไร้มูลค่า ไปยังที่อยู่แบบสุ่ม เพื่อเอาเลขพัสดุไปอัปเดตในระบบ สร้างยอดขายและรีวิวปลอมให้ร้านตัวเอง หรือเป็นมิจฉาชีพที่หวังเก็บเงินปลายทาง (COD) จากความไม่รู้ของผู้รับ
            </p>
  
            <h6 className="fw-bold mt-4 border-bottom pb-2">🛡️ การป้องกันตนเองจากพัสดุปลอมแปลง</h6>
            <ul className="text-muted mb-0">
              <li><b>ไม่ชำระเงินและปฏิเสธการรับสินค้า</b> แจ้งขนส่งตีกลับทันทีสำหรับพัสดุที่ไม่ได้สั่ง</li>
              <li>อัปเดตรหัสผ่านบัญชีผู้ใช้อย่างสม่ำเสมอ และไม่ใช้รหัสผ่านซ้ำกับเว็บอื่น</li>
              <li>หลีกเลี่ยงการโพสต์ข้อมูลส่วนบุคคล เบอร์โทรศัพท์ หรือที่อยู่ ลงบนพื้นที่สาธารณะหรือโซเชียลมีเดีย</li>
            </ul>
          </div>
        )
      },
      {
        title: "วิธีลบบัญชีผู้ใช้งานถาวร", 
        detail: (
          <div>
            <p>หากคุณต้องการยกเลิกการใช้งานและลบบัญชีผู้ใช้ของคุณออกจากระบบอย่างถาวร สามารถทำได้ตามขั้นตอนต่อไปนี้:</p>
            <ol className="text-muted">
              <li>ไปที่เมนู <b>การตั้งค่าบัญชี (Account Settings)</b></li>
              <li>เลื่อนไปที่ส่วนล่างสุด และเลือก <b>"ขอลบบัญชีผู้ใช้งาน"</b></li>
              <li>อ่านเงื่อนไขการลบบัญชีให้ครบถ้วน และกดยืนยัน</li>
            </ol>
            <div className="alert alert-danger py-2 mb-0">
              <b>⚠️ โปรดทราบ:</b> การลบบัญชีเป็นการกระทำที่ไม่สามารถย้อนกลับได้ ข้อมูลประวัติการสั่งซื้อ โค้ดส่วนลด และคะแนนสะสมทั้งหมดจะถูกลบทิ้งถาวร และคุณไม่สามารถใช้เบอร์โทรศัพท์/อีเมลเดิมสมัครใหม่ได้เป็นเวลา 30 วัน
            </div>
          </div>
        )
      }
    ]
  },
  {
    title: "ข้อกำหนดและเงื่อนไข (T&C)",
    array: [
      {
        title: "ข้อกำหนดและเงื่อนไข สินค้าพรีออเดอร์ (Pre-Order)", 
        detail: (
          <div className="bg-light p-4 rounded border">
            <h5 className="fw-bold text-center mb-4 text-primary">นโยบายการสั่งสินค้าผ่าน Pre-Order</h5>
            <p className="text-center text-muted mb-4 text-sm">ข้อกำหนดนี้ใช้บังคับกับการสั่งซื้อสินค้าประเภท Pre-Order และการนำเข้า/ขนส่งจากต่างประเทศทุกรายการบนแพลตฟอร์ม</p>
        
            <div className="accordion" id="accordionPreOrder">
              
              <div className="mb-3">
                <h6 className="fw-bold mb-2">1. ลักษณะของสินค้า Pre-Order</h6>
                <p className="text-muted text-sm ps-3 border-start border-2 border-secondary mb-0">สินค้าในหมวดนี้เป็นสินค้าที่สั่งผลิตหรือสั่งนำเข้าจากต่างประเทศ <b>ไม่มีสต็อกพร้อมส่งในประเทศไทย</b> ผู้ซื้อจะต้องชำระเงินเต็มจำนวน (หรือมัดจำตามที่ร้านค้าระบุ) ก่อนที่ร้านค้าจะดำเนินการสั่งซื้อกับโรงงานหรือตัวแทนจำหน่าย</p>
              </div>

              <div className="mb-3">
                <h6 className="fw-bold mb-2">2. ระยะเวลาการจัดส่ง (ETA)</h6>
                <p className="text-muted text-sm ps-3 border-start border-2 border-secondary mb-0">ระยะเวลาการจัดส่งที่ระบุในหน้าสินค้า เป็นเพียง <b>"การประมาณการ" (Estimated Time of Arrival)</b> ซึ่งอาจเกิดความล่าช้าจากหลายปัจจัย เช่น กระบวนการผลิต, การตรวจสอบของศุลกากร, สภาพอากาศ, หรือการขนส่งระหว่างประเทศ ทางบริษัทขอสงวนสิทธิ์ไม่รับผิดชอบต่อความล่าช้าที่อยู่นอกเหนือการควบคุม</p>
              </div>

              <div className="mb-3">
                <h6 className="fw-bold mb-2">3. นโยบายการยกเลิกและการคืนเงิน</h6>
                <p className="text-muted text-sm ps-3 border-start border-2 border-secondary mb-0">เมื่อทำการชำระเงินเรียบร้อยแล้ว <b>ไม่สามารถยกเลิก เปลี่ยนแปลงสี/ไซส์ หรือขอคืนเงินได้ในทุกกรณี</b> (ยกเว้นในกรณีที่โรงงานประกาศยกเลิกการผลิต หรือบริษัทไม่สามารถจัดหาสินค้ามาส่งให้ลูกค้าได้เท่านั้น ทางระบบจะทำการคืนเงินให้ 100%)</p>
              </div>

              <div className="mb-3">
                <h6 className="fw-bold mb-2">4. ภาษีและอากรนำเข้า</h6>
                <p className="text-muted text-sm ps-3 border-start border-2 border-secondary mb-0">ราคาสินค้าที่แสดงเป็นสกุลเงินบาท (THB) <b>อาจยังไม่รวมภาษีนำเข้าและค่าธรรมเนียมศุลกากร</b> (ขึ้นอยู่กับข้อตกลงของแต่ละร้านค้า) หากเกิดค่าใช้จ่ายส่วนนี้เพิ่มเติม ลูกค้าอาจต้องเป็นผู้รับผิดชอบค่าใช้จ่ายตามจริงที่เจ้าหน้าที่ประเมิน</p>
              </div>

              <div className="mb-3">
                <h6 className="fw-bold mb-2">5. การเคลมสินค้าชำรุด</h6>
                <p className="text-muted text-sm ps-3 border-start border-2 border-secondary mb-0">เนื่องจากเป็นการส่งตรงจากต่างประเทศ กรณีสินค้ามีตำหนิจากโรงงาน (Defect) หรือเสียหายจากการขนส่ง ผู้ซื้อต้องแจ้งเรื่องเข้ามา <b>ภายใน 7 วัน นับจากวันที่เซ็นรับพัสดุ</b> พร้อมแนบวิดีโอแกะกล่องที่ไม่มีการตัดต่อ เพื่อให้บริษัทดำเนินการส่งเรื่องประสานงานกับผู้ผลิตต่อไป ทั้งนี้การตัดสินใจเคลมขึ้นอยู่กับดุลยพินิจของโรงงานต้นทาง</p>
              </div>

            </div>
            
            <hr className="my-4"/>
            <p className="text-muted text-center mb-0" style={{ fontSize: "0.8rem" }}>
              การกดยืนยันคำสั่งซื้อ ถือว่าผู้ซื้อได้อ่าน เข้าใจ และยอมรับข้อกำหนดและเงื่อนไขนี้ทุกประการ ทางบริษัทขอสงวนสิทธิ์ในการเปลี่ยนแปลงเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
            </p>
          </div>
        )
      }
    ]
  }
];
export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      main_index: 0,
      sub_index: -1,
    };
  }
  componentDidMount() {
    loading(false);
  }
  render() {
    const {main_index, sub_index} = this.state;

    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="row d-flex justify-content-center mx-0">
                 <div className="col-12 col-sm-11 col-md-10 col-lg-2 col-xl-2 pt-5 mt-3">
                  {/* เมนู */}
                  <div className="py-3">
                    {help.map((item, index) => (
                      <div className="pt-2 pb-2 border-bottom pointer" onClick={() => {this.setState({main_index: index, sub_index: -1})}}>
                      {item.title}
                    </div>
                    ))}
                  </div>
                </div>
                <div className="col-12 col-sm-11 col-md-10 col-lg-9 col-xl-7 col-xxl-6 my-4 px-3 min-vh-100">
          <h4 className="fw-bold mb-3">ศูนย์ช่วยเหลือ</h4>
          <div className="rounded-4 bg-white p-3 mb-2 border">
            {sub_index === -1 ?(<div>
              {help[main_index]?.array?.map((item, index) => (
                      <div className="pt-2 pb-2 border-bottom pointer" onClick={() => {this.setState({sub_index: index })}}>
                      {item.title}
                    </div>
                    ))}
            </div>):(
            <div>
              <h3 className="fw-bold mb-3">{help[main_index]?.array[sub_index]?.title}</h3>
              {help[main_index]?.array[sub_index]?.detail}
            </div>
            )}

          </div>
          {sub_index === -1 && (
          <div className="rounded-4 bg-white p-3 mb-2 border">
            <h6 className="fw-bold mb-3">บริการหลังการขาย</h6>
            <a href="https://page.line.biz/account/@488dmsci" target="_blank" className="d-flex justify-content-between mb-3 pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex">
                  <div className="me-1">
                  <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                        fill="#000000"
                        width={22}
                      >
                        <path d="M375 260.8L375 342.1C375 344.2 373.4 345.8 371.3 345.8L358.3 345.8C357 345.8 355.9 345.1 355.3 344.3L318 294L318 342.2C318 344.3 316.4 345.9 314.3 345.9L301.3 345.9C299.2 345.9 297.6 344.3 297.6 342.2L297.6 260.9C297.6 258.8 299.2 257.2 301.3 257.2L314.2 257.2C315.3 257.2 316.6 257.8 317.2 258.8L354.5 309.1L354.5 260.9C354.5 258.8 356.1 257.2 358.2 257.2L371.2 257.2C373.3 257.1 375 258.8 375 260.7L375 260.8zM281.3 257.1L268.3 257.1C266.2 257.1 264.6 258.7 264.6 260.8L264.6 342.1C264.6 344.2 266.2 345.8 268.3 345.8L281.3 345.8C283.4 345.8 285 344.2 285 342.1L285 260.8C285 258.9 283.4 257.1 281.3 257.1zM249.9 325.2L214.3 325.2L214.3 260.8C214.3 258.7 212.7 257.1 210.6 257.1L197.6 257.1C195.5 257.1 193.9 258.7 193.9 260.8L193.9 342.1C193.9 343.1 194.2 343.9 194.9 344.6C195.6 345.2 196.4 345.6 197.4 345.6L249.6 345.6C251.7 345.6 253.3 344 253.3 341.9L253.3 328.9C253.3 327 251.7 325.2 249.8 325.2L249.9 325.2zM443.6 257.1L391.3 257.1C389.4 257.1 387.6 258.7 387.6 260.8L387.6 342.1C387.6 344 389.2 345.8 391.3 345.8L443.5 345.8C445.6 345.8 447.2 344.2 447.2 342.1L447.2 329C447.2 326.9 445.6 325.3 443.5 325.3L408 325.3L408 311.7L443.5 311.7C445.6 311.7 447.2 310.1 447.2 308L447.2 294.9C447.2 292.8 445.6 291.2 443.5 291.2L408 291.2L408 277.5L443.5 277.5C445.6 277.5 447.2 275.9 447.2 273.8L447.2 260.8C447.1 258.9 445.5 257.1 443.5 257.1L443.6 257.1zM576 157.4L576 483.4C575.9 534.6 533.9 576.1 482.6 576L156.6 576C105.4 575.9 63.9 533.8 64 482.6L64 156.6C64.1 105.4 106.2 63.9 157.4 64L483.4 64C534.6 64.1 576.1 106.1 576 157.4zM505.6 297.5C505.6 214.1 421.9 146.2 319.2 146.2C216.5 146.2 132.8 214.1 132.8 297.5C132.8 372.2 199.1 434.9 288.7 446.8C310.5 451.5 308 459.5 303.1 488.9C302.3 493.6 299.3 507.3 319.2 499C339.1 490.7 426.5 435.8 465.7 390.8C492.7 361.1 505.6 331 505.6 297.7L505.6 297.5z" />
                      </svg>
                      </div>
                  ตัวแทนฝ่ายบริการลูกค้า</div>
                <span className="icon text-secondary">{"\uf054"}</span>
              </a>
              <a href="mailto:support@zenithlink.tech" target="_blank" className="d-flex justify-content-between pb-2 border-bottom text-decoration-none text-dark" rel="noreferrer">
                <div className="d-flex"><span className="icon ms-1 me-2">{"\uf0e0"}</span>ติดต่อทางอีเมล</div>
                <span className="icon text-secondary">{"\uf054"}</span>
              </a>
          </div>
          )}
        </div>
        </div>

        <Footer />
      </div>
    );
  }
}
